/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGeneric.mustache
// synched 02.02.2023
import * as yup from 'yup';
import typia from 'typia';
import * as fastJSON from 'fast-json-stringify';
import { Options, ArraySchema, ObjectSchema } from 'fast-json-stringify';
import { exists, mapValues } from '../runtime';
/*
causes circular dependendies
*/
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelGenericInterfaces.mustache
// synced: 17.07.2023
/**
 *
 * @export
 * @interface CreateEntityResponse
 *
 */
// create custom validators for the regexes
typia.customValidators.insert("pattern_CreateEntityResponse_id")("string")(() => {
    const regex = new RegExp(/^[a-f0-9]{24}$/);
    return (value: string) => !!regex.exec(value);
});
export interface CreateEntityResponse {
    /**
     * MongoDB ObjectId
     * #type string
     * #memberof CreateEntityResponse
        
        
    * @pattern_CreateEntityResponse_id
         */
    id: string;
}
/**
 * Check if a given object implements the CreateEntityResponse interface.
 */
export function instanceOfCreateEntityResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    return isInstance;
}
/* LIGHTLY CUSTOM START -> modelGeneric */
export const CreateEntityResponseTypiaAssertEquals = (input: any) => {
    return ((input: any): CreateEntityResponse => {
        const __is = (input: any, _exceptionable: boolean = true): input is CreateEntityResponse => {
            const $is_custom = (typia.createAssertEquals as any).is_custom;
            const $io0 = (input: any, _exceptionable: boolean = true): boolean => "string" === typeof input.id && $is_custom("pattern_CreateEntityResponse_id", "string", "", input.id) && (1 === Object.keys(input).length || Object.keys(input).every((key: any) => {
                if (["id"].some((prop: any) => key === prop))
                    return true;
                const value = input[key];
                if (undefined === value)
                    return true;
                return false;
            }));
            return "object" === typeof input && null !== input && $io0(input, true);
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateEntityResponse => {
                const $guard = (typia.createAssertEquals as any).guard;
                const $is_custom = (typia.createAssertEquals as any).is_custom;
                const $join = (typia.createAssertEquals as any).join;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => ("string" === typeof input.id && ($is_custom("pattern_CreateEntityResponse_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_CreateEntityResponse_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                })) && (1 === Object.keys(input).length || (false === _exceptionable || Object.keys(input).every((key: any) => {
                    if (["id"].some((prop: any) => key === prop))
                        return true;
                    const value = input[key];
                    if (undefined === value)
                        return true;
                    return $guard(_exceptionable, {
                        path: _path + $join(key),
                        expected: "undefined",
                        value: value
                    });
                })));
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "CreateEntityResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CreateEntityResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    })(input);
};
export const CreateEntityResponseTypiaAssertStringify = (input: CreateEntityResponse): string => {
    return ((input: any): string => { const assert = (input: any): CreateEntityResponse => {
        const __is = (input: any): input is CreateEntityResponse => {
            const $is_custom = (typia.createAssertStringify as any).is_custom;
            return "object" === typeof input && null !== input && ("string" === typeof (input as any).id && $is_custom("pattern_CreateEntityResponse_id", "string", "", (input as any).id));
        };
        if (false === __is(input))
            ((input: any, _path: string, _exceptionable: boolean = true): input is CreateEntityResponse => {
                const $guard = (typia.createAssertStringify as any).guard;
                const $is_custom = (typia.createAssertStringify as any).is_custom;
                const $ao0 = (input: any, _path: string, _exceptionable: boolean = true): boolean => "string" === typeof input.id && ($is_custom("pattern_CreateEntityResponse_id", "string", "", input.id) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string (@pattern_CreateEntityResponse_id)",
                    value: input.id
                })) || $guard(_exceptionable, {
                    path: _path + ".id",
                    expected: "string",
                    value: input.id
                });
                return ("object" === typeof input && null !== input || $guard(true, {
                    path: _path + "",
                    expected: "CreateEntityResponse",
                    value: input
                })) && $ao0(input, _path + "", true) || $guard(true, {
                    path: _path + "",
                    expected: "CreateEntityResponse",
                    value: input
                });
            })(input, "$input", true);
        return input;
    }; const stringify = (input: CreateEntityResponse): string => {
        const $string = (typia.createAssertStringify as any).string;
        const $is_custom = (typia.createAssertStringify as any).is_custom;
        return `{"id":${$string((input as any).id)}}`;
    }; return stringify(assert(input)); })(input);
};
export const CreateEntityResponseValidatorShape = {
    'id': yup.string().matches(/^[a-f0-9]{24}$/).defined(),
};
export const CreateEntityResponseValidator = yup.object().shape(CreateEntityResponseValidatorShape);
export const CreateEntityResponseStringifyShapeProperties: ObjectSchema['properties'] = {
    'id': {
        'type': 'string',
        'pattern': "/^[a-f0-9]{24}$/".slice(1, -1),
    } as unknown as fastJSON.StringSchema,
};
export const CreateEntityResponseStringifyShape: ObjectSchema = {
    title: 'CreateEntityResponse Stringifier',
    type: 'object',
    properties: {
        ...CreateEntityResponseStringifyShapeProperties
    },
    required: [
        'id',
    ],
};
export const CreateEntityResponseStringifyCompiled = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(CreateEntityResponseStringifyShape, {
        ajv: {
            // since we are already doing this with yup, lets skip
            validateSchema: false,
            ownProperties: true,
            validateFormats: false,
        },
        largeArrayMechanism: 'json-stringify',
        largeArraySize: 1000,
    } as Options)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
export const CreateEntityResponseStringify: (data: CreateEntityResponse) => string = CreateEntityResponseStringifyCompiled;
/* LIGHTLY CUSTOM END -> Generic */
export function CreateEntityResponseFromJSON(json: any): CreateEntityResponse {
    return CreateEntityResponseFromJSONTyped(json, false);
}
export function CreateEntityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEntityResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    /* causes circular depdendencies
*/
    return {
        'id': json['id'],
    };
}
export function CreateEntityResponseToJSON(value?: CreateEntityResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
    };
}
